function FeatureSection({ feature }) {
    return (
        <div className="flex flex-col items-center gap-3">
            <div className='size-7'>
                <img className='size-full' src={feature.imageLink} alt={feature.altText} />
            </div>

            <h1 className='font-semibold text-[16px] leading-[26px] text-[#FFFFFF]'>{feature.Heading}</h1>
        </div>
    )
}

function FeaturesTwo({ item }) {
    return (
        <div className='w-full flex flex-col gap-5 px-4'>
            {item.item.featureItems.map((feature, index) => {
                return (
                    <FeatureSection 
                        key={index} 
                        feature={feature}
                    />
                )
            })}
        </div>
    );
}

export default FeaturesTwo;
